var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnrecognizedThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V26C32 29.3137 29.3137 32 26 32H6C2.68629 32 0 29.3137 0 26V6Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0269 11.6777H9.86071V15.8544H9.79837L6.96201 11.6777H5.12305V19.657H7.28928V15.4647H7.33603L10.2192 19.657H12.0269V11.6777Z",
    fill: "#DDDDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5088 19.657H15.675V16.5401H18.7763V14.7946H15.675V13.4232H19.1192V11.6777H13.5088V19.657Z",
    fill: "#DDDDDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1549 13.4232H22.5549V19.657H24.6899V13.4232H27.0899V11.6777H20.1549V13.4232Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnrecognizedThumbnail);
export default __webpack_public_path__ + "static/media/unrecognized-thumbnail.3e01e3049e331da08cfd19d563d3bb1e.svg";
export { ForwardRef as ReactComponent };